var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import store from '../../store';
/** Fetches data from remote server, then places that data into Store (by default, but can be changed), then returns the full response */
export default function fetchRecords(entity, fetchParams) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!entity) {
            debugger;
            return { result: 'error', messages: [{ message: 'entity is not defined in fetchRecords' }] };
        }
        const response = yield store.dispatch(entity + '/fetch', fetchParams);
        // process case when old API endpoints are queried, that return DataRow[] in root of response
        if (Array.isArray(response))
            return { result: 'success', data: response };
        return response;
    });
}
